








import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({
  name: 'Stepper',
  components: {},
})
export default class Registration extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) private forward!: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) private back!: boolean

  private step(val: number) {
    this.$emit('step', val)
  }
}
